import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from 'src/app/components/base/base.component';
import { Student } from 'src/app/core/models/student';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseService } from 'src/app/core/services/base.service';
import { StudentService } from '../../core/services/student.service';

@Component({
  selector: 'app-student-profile',
  templateUrl: './student-profile.component.html',
  styleUrls: ['./student-profile.component.scss']
})
export class StudentProfileComponent extends BaseComponent implements OnInit {

  userFullName: string;
  studentId: number;

  student = {} as Student;
  tokenValid: boolean;

  isTeacher: string

  constructor(
    public baseService: BaseService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private studentService: StudentService
  ) { super() }

  ngOnInit(): void {
    this.userFullName = localStorage.getItem('userFullName');

    var studId = localStorage.getItem('studentId');
    this.studentId = Number(studId);

    const token = localStorage.getItem('token');
    const isTeacher = localStorage.getItem('isTeacher');
    this.isTeacher = isTeacher
    if (token && isTeacher) { this.tokenValid = true; }
    else { this.tokenValid = false; }
    
    this.loadData();
  }

  loadData() {
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data => {
        this.student = data.student.result.returnData as Student;
        // console.log(this.student)
      });
  }

  viewStudProfile(id) {
    this.router.navigate(['/student-profile/edit', this.studentId])
  }

  viewStudCourses(id) {
    this.router.navigate(['/student-courses/edit', this.studentId]);
  }

  viewStudSettings(id) {
    this.router.navigate(['/student-settings/edit', this.studentId]);
  }

  viewWishlist(id) {
    this.router.navigate(['/wishlist/edit', this.studentId]);
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('token');
    localStorage.removeItem('academyToken');
    localStorage.removeItem('studentId');
    localStorage.removeItem('profileImg');
    localStorage.removeItem('userId');
    localStorage.removeItem('isTeacher');
    localStorage.removeItem('teacherId');
    localStorage.removeItem('userFullName');
    localStorage.removeItem('token');
    // localStorage.clear();
    this.router.navigate(['/home']);

    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 200);
    if (!localStorage.getItem('up')) {
      localStorage.setItem('up', 'no reload');
      location.reload();
    } else {
      localStorage.removeItem('up');
    }
  }

}
